export default __webpack_public_path__ + "static/media/green-check-mark.61275c97.svg";